module.exports = __webpack_public_path__ + "static/media/maos.ac964e7a.png";